import { render, staticRenderFns } from "./crearPermiso.vue?vue&type=template&id=1ac573e1&scoped=true"
import script from "./crearPermiso.vue?vue&type=script&lang=js"
export * from "./crearPermiso.vue?vue&type=script&lang=js"
import style0 from "./crearPermiso.vue?vue&type=style&index=0&id=1ac573e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac573e1",
  null
  
)

export default component.exports